<template>
  <div v-for="(child, k) in items" :key="k">
    <RouterLink
      v-if="child && child.link !== undefined"
      class="text-body-3 d-block mt-3 ui-sidebar-menu-grid__link"
      :to="child.link"
    >
      {{ child.label }}
    </RouterLink>
  </div>
</template>

<script setup lang="ts">
import { type SidebarItem } from '~/app/layouts/sidebar';
import { RouterLink } from '~/infrastructure';

export interface Props {
  items?: SidebarItem[];
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.ui-sidebar-menu-grid__link {
  color: rgb(var(--v-theme-text-primary));

  &:hover {
    color: rgb(var(--v-theme-text-link));
  }
}
</style>
